export default "__VITE_ASSET__C1G0V$4j__"